import { combineReducers } from "redux";
import orderResponse from "./orderReducer";
import orderDetailResponse from "./orderDetailReducer";
import orderItemDetailsResponse from "./orderItemDetailReducer";
import quotationResponse from "./quotationReducer";
import invoiceResponse from "./invoiceReducer";
import duePaymentsResponse from "./duePaymentsReducer";
import cartsResponse from "./cartsReducer";
import searchResultsResponse from "./searchResultsReducer";
import contractsResponse from "./contractsReducer";
/* TT Custom Start */
import ttQuotToOrderDetailsResponse from "./ttQuoteToOrederDetailsReducer";
import ttQuoteToOrderResponse from "./ttQuoteToOrderReducer";
import ttDocumentsResponse from "./ttDocumentsReducer";
/* TT Custom End */

export const rootReducer = combineReducers({
  orderResponse,
  orderDetailResponse,
  orderItemDetailsResponse,
  quotationResponse,
  invoiceResponse,
  duePaymentsResponse,
  cartsResponse,
  searchResultsResponse,
  contractsResponse,
  /* TT Custom START */
  ttQuotToOrderDetailsResponse,
  ttQuoteToOrderResponse,
  ttDocumentsResponse,
  /* TT Custom End */
});
